import React, { useState, useEffect } from 'react';
import Datatables from '../../DataTable/Datatables';
import Button from 'react-bootstrap/Button';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Axios } from '../../components/common/Axios';
import { FaTrashAlt, FaEdit } from 'react-icons/fa';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import { ToastContainer, toast } from 'react-toastify';
import Form from 'react-bootstrap/Form';
import { useForm } from 'react-hook-form';
import Swal from "sweetalert2";
import { notify, notifyErr } from '../../components/common/norify';

const Values = () => {

    // 

    const [data, setData] = useState([]);
    const [pending, setPending] = useState(true);
    const [show, setShow] = useState(false);
    const [showUpdate, setShowUpdate] = useState(false)
    const [id, setId] = useState('');
    const [formData, setFormData] = useState({
        title: '',
        content: '',
    })
    const [updateFormData, setUpdateFormData] = useState({
        title: '',
        content: '',
    })

    const handleShow = (row) => {
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
        setFormData({
            title: '',
            content: '',
        })
        reset({
            title: '',
            content: '',
        })
    };


    const handleCloseUpdate = () => {
        setShowUpdate(false);
        setUpdateFormData({
            title: '',
            content: '',
        })
        reset1({
            title: '',
            content: '',
        })
        setId('');
    }
    const handleShowUpdate = (row) => {
        setShowUpdate(true)
        setId(row._id)
        getValue(row._id);
    }

    const getData = async () => {
        try {
            const valueData = await Axios.get(`/api/value`);
            let value = valueData.data.data;
            setData(value);

        } catch (error) {
            // Handle errors
            console.error('Error:', error);
        } finally {
            setPending(false)
        }
    }

    useEffect(() => {
        getData();
    }, []);

    const handleInputChange = (fieldName, value) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [fieldName]: value,
        }));
    };

    const handleInputChange1 = (fieldName, value) => {
        setUpdateFormData((prevFormData) => ({
            ...prevFormData,
            [fieldName]: value,
        }));
    };


    const tableData = {
        columns: [
            {
                name: <th className='fs-6 ' >#</th>,
                cell: (row, index) => index + 1,
                width: '150px',
            },
            {
                name: <th className='fs-6 '>Title</th>,
                selector: (row) => row.title,
                width: '250px',
            },
            {
                name: <th className='fs-6 '>Content</th>,
                selector: (row) => row.content,
                width: '300px',
            },
            {
                name: <th className='fs-6 '>Action</th>,
                selector: (row) => (
                    <div className='d-flex' style={{ gap: '10px' }}>

                        <Button className='Add_btn_ text-white' variant='contained' style={{ float: 'right', backgroundColor: '#0C0833' }}
                            onClick={() => handleShowUpdate(row)}
                        >
                            <FaEdit />
                        </Button>

                        <Button className='_delete_btn_ text-white  bg-danger' variant='contained' style={{ float: 'right', backgroundColor: '#0C0833' }}
                            onClick={() => confirmDelete(row._id)}
                        ><FaTrashAlt /></Button>
                    </div>
                ),
                right: true,
            },
        ],
    };

    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const onSubmit = async () => {
        setPending(true)
        try {
            const response = await Axios.post('/api/value', formData,
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                });
            if (response.status === 200 || 201) {
                notify('value added Successfully');
                handleClose();
                setTimeout(() => {
                    getData();
                }, 1500);
            }
        } catch (error) {
            notifyErr('Something went wrong')
            console.error(error);
        } finally {
            setPending(false)
        }

    };

    const { register: register1, handleSubmit: handleSubmit1, reset: reset1, formState: { errors: errors1 } } = useForm();
    const getValue = async (id) => {
        try {
            const valueData = await Axios.get(`/api/value/${id}`);
            let value = valueData.data;
            if (value) {
                setUpdateFormData({
                    title: value.title,
                    content: value.content,
                })
                reset1({
                    title: value.title,
                    content: value.content,
                })

            }
        } catch (error) {
            // Handle errors
            console.error('Error:', error);
        }
    };



    const onUpdate = async () => {
        setPending(true);
        try {
            const response = await Axios.put(`/api/value/${id}`, updateFormData,
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                });
            if (response.status === 200 || 201) {
                notify('value updated Successfully');
                handleCloseUpdate();
                setTimeout(() => {
                    getData();
                }, 1500);
            }
        } catch (error) {
            notifyErr('Something went wrong')
            console.error(error);
        } finally {
            setPending(false)
        }
    };


    const handleDelete = async (id) => {
        try {
            const response = await Axios.delete(`/api/value/${id}`);
            if (response.status === 200) {
                setTimeout(() => {
                    getData();
                }, 2000);
            }
            Swal.fire({
                title: 'Deleted!',
                text: 'Your data has been deleted.',
                icon: 'success',
                confirmButtonColor: '#0C0833',
            });
        } catch (error) {
            console.error(error);

            Swal.fire({
                title: 'Error',
                text: 'An error occurred while deleting the data.',
                icon: 'error',
            });
        }
    };

    const confirmDelete = (id) => {
        Swal.fire({
            title: 'Are you sure to Delete?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0C0833',
            cancelButtonColor: 'grey',
            confirmButtonText: 'Yes, delete it!',
        }).then((result) => {

            if (result.value) {
                console.log(result)
                handleDelete(id);
            }
        });
    };



    return (
        <>
            <div className='profile-page'>
                <Helmet>
                    <title>values</title>
                </Helmet>
                <section className="wrapper _blogs">
                    <div className="row">
                        <div className="col-lg-6">
                            <span className='p-3 fw-bold'>values</span>
                        </div>
                        <div className='col-lg-6 px-2 btn-d '>

                            <div className=' pb-2 btn-d d-flex justify-content-end'>
                                <Button className='Add_btn_ text-white' variant='contained' style={{ float: 'right' }}
                                    onClick={handleShow}
                                >
                                    Add values
                                </Button>

                            </div>
                        </div>
                    </div>
                </section>

                <section className='mt-2'>
                    <Card>
                        <div className="main" >
                            <Datatables data={data} columns={tableData.columns} />
                        </div>
                    </Card>
                </section>


            </div>

            {/* Add Modal */}
            <Modal size="lg" show={show} onHide={handleClose} className='' style={{ zIndex: '99999' }}>
                <ToastContainer />
                <Modal.Header closeButton>

                    <Modal.Title>Add value</Modal.Title>
                </Modal.Header>
                <Form className='row m-2' onSubmit={handleSubmit(onSubmit)}>
                    <Form.Group className="mb-3 col-12">
                        <Form.Label>Title</Form.Label>
                        <Form.Control type="text" placeholder="Title" value={formData.title}
                            {...register("Title", {
                                required: true,
                                onChange: (e) => handleInputChange('title', e.target.value)
                            })}
                        />

                        {errors.Title && (
                            <div className='errMsg text-danger'>Title is required</div>
                        )}

                    </Form.Group>


                    <Form.Group className="mb-3 col-lg-12 col-md-12 col-sm-12 col-12">
                        <Form.Label>Content</Form.Label>
                        <Form.Control as="textarea" rows={4} placeholder="Content" id="content" value={formData.content}
                            {...register("content", {
                                required: true,
                                onChange: (e) => handleInputChange('content', e.target.value)
                            })}
                        />
                    </Form.Group>


                    <Modal.Footer>
                        <Button type="submit" variant="contained" className='text-white' style={{ backgroundColor: '#0C0833' }}  >
                            Add
                        </Button>
                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>


            {/* update */}
            <Modal size="lg" show={showUpdate} onHide={handleCloseUpdate} className='' style={{ zIndex: '99999' }}>
                <ToastContainer />
                <Modal.Header closeButton>

                    <Modal.Title>Update value</Modal.Title>
                </Modal.Header>
                <Form className='row m-2' onSubmit={handleSubmit1(onUpdate)}>
                    <Form.Group className="mb-3 col-12">
                        <Form.Label>Title</Form.Label>
                        <Form.Control type="text" placeholder="Title" value={updateFormData.title}
                            {...register1("updateTitle", {
                                required: false,
                                onChange: (e) => handleInputChange1('title', e.target.value)
                            })}
                        />

                        {errors1.updateTitle && (
                            <div className='errMsg text-danger'>Title is required</div>
                        )}

                    </Form.Group>



                    <Form.Group className="mb-3 col-lg-12 col-md-12 col-sm-12 col-12">
                        <Form.Label>Content</Form.Label>
                        <Form.Control as="textarea" rows={4} placeholder="Content" id="content" value={updateFormData.content}
                            {...register1("updateContent", {
                                required: false,
                                onChange: (e) => handleInputChange1('content', e.target.value)
                            })}
                        />
                    </Form.Group>
                    <Modal.Footer>
                        <Button type="submit" variant="contained" className='text-white' style={{ backgroundColor: '#0C0833' }}  >
                            Update
                        </Button>
                        <Button variant="secondary" onClick={handleCloseUpdate}>
                            Close
                        </Button>

                    </Modal.Footer>
                </Form>

            </Modal>
        </>
    )
}

export default Values